import moment from 'moment'
import React,
{ Fragment } from 'react'

import { MenuButton } from '@driftt/dds'
import {
  A,
  Avatar,
  Div,
  Input,
  ToolTip 
} from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { getSegmentTypeDisplayName } from 'components/Segments/constants/SegmentTypes'

const SelectCell = ({ id }, onSelect, isSelected) => {
  return (
    <Input type="checkbox" checked={isSelected}
      onChange={(event) => onSelect(id, event)} />
  )
}

const SegmentNameCell = (segment, history) => (
  <Div className="contacts-segments-list-name-cell">
    <A href={`/contacts/segments/${segment.id}`}>{segment.name}</A>
  </Div>
)

const SegmentTypeCell = segment => {
  const type = getSegmentTypeDisplayName(segment.type)

  return (
    <Div className="contacts-segments-list-name-cell">
      {type}
    </Div>
  )
}

const CreatedByCell = (segment, users) => {
  const creator = users.find(user => user.id === segment.authorId)

  return (
    <Div className="contacts-segments-list-created-by-cell" data-private>
      {!!creator && 
        <Fragment>
          <Avatar user={creator} />
          {creator.name ? creator.name : creator.email}
        </Fragment>
      }
      {!creator && 
        <span>User unavailable</span>
      }
    </Div>
  )
}

const CreatedOnCell = segment => (
  <Div className="contacts-segments-list-created-on-cell">
    {moment(segment.createdAt).format('MM/DD/YY hh:mmA')}
  </Div>
)

const UpdatedOnCell = segment => (
  <Div className="contacts-segments-list-updated-on-cell">
    {moment(segment.updatedAt).fromNow()}
  </Div>
)

const renderEnrollInSegmentAction = (segment, onTarget, isLoading) => {
  return (
    <Div className="contacts-segments-list--enroll-segment">
      <MenuButton buttonText='Add to playbook' loading={isLoading}
        options={[
          {
            name: 'Add to existing playbook',
            action: hideDropdown => {
              hideDropdown()
              onTarget({
                segment,
                createNew: false 
              })
            },
          },
          {
            name: 'Create a new playbook',
            action: hideDropdown => {
              hideDropdown()
              onTarget({
                segment,
                createNew: true 
              })
            },
          },
        ]}/>
    </Div>
  )
}

const ActionsCell = (
  segment, onDelete, onTarget, isLoading, onCreateFastlanePlaybook
) => (
  <Div>
    {renderEnrollInSegmentAction(
      segment, onTarget, isLoading, onCreateFastlanePlaybook
    )}
    {segment.isSystemOwned ?
      <Div>
        <ToolTip flow="up" component={`You can't delete a segment used in a bot playbook`}>
          <Div>
            <Icon name="trash" width={14} />
          </Div>
        </ToolTip>
      </Div>
      :
      <Div className="contacts-segments-list-delete-cell" onClick={() => onDelete(segment.id)}>
        <ToolTip flow="up" component={`Delete segment`}>
          <Icon name="trash" width={14} />
        </ToolTip>
      </Div>
    }
  </Div>
)

export const AllSegmentsFormatter = ({
  history,
  isLoading,
  onDelete,
  onSelect,
  onTarget,
  segment,
  selectedSegments,
  users,
}) => ({
  data: [
    { content: SelectCell(segment, onSelect, (selectedSegments && selectedSegments.includes(segment.id))) },
    { content: SegmentNameCell(segment, history) },
    { content: SegmentTypeCell(segment) },
    { content: CreatedByCell(segment, users) },
    { content: CreatedOnCell(segment) },
    { content: UpdatedOnCell(segment) },
    {
      content: ActionsCell(
        segment, onDelete, onTarget, isLoading
      ),
      className: 'contacts-segments-list-actions-cell' 
    },
  ]
})
